type RequestOptions = {
  responseType?: 'json' | 'text' | 'blob' | 'arrayBuffer'
  headers?: HeadersInit
  params?: { [key: string]: string | number | undefined | null }
}

export const useHttpClient = (baseUrl?: string) => {
  const runtimeConfig = useRuntimeConfig()
  const cacheStore = useCacheStore()
  const { getCachedData, setCache } = cacheStore

  const { request } = useAuthedFetch(baseUrl || runtimeConfig.public.API_URL)

  const $get = <T = any>(
    url: string,
    options: RequestOptions = {}
  ): Promise<T> => {
    options.responseType = options.responseType || 'json'
    options.params = Object.fromEntries(
      Object.entries(options.params || {}).map(([key, value]) => [
        key,
        value === null ? undefined : value,
      ])
    )

    const cacheKey = JSON.stringify({ url, params: options.params })
    const cachedData = getCachedData<T>(cacheKey)
    if (cachedData) return cachedData

    const response = request<T>(url, {
      method: 'GET',
      responseType: options.responseType,
      headers: options.headers,
      params: options.params,
    })
    setCache<T>(cacheKey, response)
    return response
  }

  const $post = <T = any>(
    url: string,
    body: any,
    options: RequestOptions = {}
  ): Promise<T> => {
    options.responseType = options.responseType || 'json'

    return request<T>(url, {
      method: 'POST',
      body,
      responseType: options.responseType,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    })
  }

  return {
    $get,
    $post,
  }
}
